import script from "./ArticlePopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlePopover.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlePopover.vue?vue&type=style&index=0&id=b5df3066&lang=css"
import "./ArticlePopover.vue?vue&type=style&index=1&id=b5df3066&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5df3066"]])

export default __exports__